export default function tabContent (document, moduleHTML, appEventEmitter) {
  const tabs = moduleHTML.querySelectorAll('button')
  const contentBlocks = moduleHTML.querySelectorAll('[data-js-content]')
  const toggleContentDisplay = (event) => {
    tabs.forEach((tab) => tab.classList.remove('bg-teal'))
    contentBlocks.forEach((contentBlock) => contentBlock.classList.add('hidden'))
    event.target.classList.add('bg-teal'); // semicolon to appease the almighty ESLint
    ['hidden', 'block'].forEach((cls) => event.target.nextSibling.classList.toggle(cls))
  }

  tabs.forEach((tab) => tab.addEventListener('click', toggleContentDisplay))
}
